/*
 * NOTE: These variables are automatically injected and replaced at build-time.
 *
 * Do not hard-code values here;
 * any changes will be overwritten during the build process.
 */
export const SDK_NAME = "@tapsioss/ripple-node";
export const SDK_VERSION = "2.3.1";
